import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {LocalStorageUtils} from '../util/local-storage.utils';
import * as base64 from 'base-64';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
   // Get the auth token from the service.
   const authToken = LocalStorageUtils.getAccessToken();
   const profile = LocalStorageUtils.getItem('profile');
   // req.headers.set('Xxx-App-Version', '1.0.0 ');
   // req.headers.set('Xxx-Api-Key', '63cf90565e5e8b2802cb6ac98435a0ca');

 

   if (authToken && profile) {
     // Clone the request and replace the original headers with
     // cloned headers, updated with the authorization.
     const data = base64.encode(`${JSON.parse(profile).user_id}|${authToken}`);
     // const authReq = req.clone({
       
     //   headers: req.headers.set('Authorization-data', data)
     // });

     const authReq = req.clone({
       setHeaders: {
         'Authorization-data': data,
         'Xxx-App-Version': '1.0.0',
         'Xxx-Api-Key': '63cf90565e5e8b2802cb6ac98435a0ca'
       }
     });

     // send cloned request with header to the next handler.
     return next.handle(authReq);
   }

   const request = req.clone({
     setHeaders: {
    //   'Authorization-data': data,
       'Xxx-App-Version': '1.0.0',
       'Xxx-Api-Key': '63cf90565e5e8b2802cb6ac98435a0ca'
     }
   });

   return next.handle(request);
 }
}
